import { render, staticRenderFns } from "./PricingPlansList.vue?vue&type=template&id=f46317ea&"
import script from "./PricingPlansList.vue?vue&type=script&lang=js&"
export * from "./PricingPlansList.vue?vue&type=script&lang=js&"
import style0 from "./PricingPlansList.vue?vue&type=style&index=0&id=f46317ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports